import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useRouter } from 'next/router';

import getLayerStore from '@stores/LayerStore';
import { getMetaContent } from '@lib/metaContent';
import { formatPrice, getStreetNameFromAddress } from '@lib/utils';
import { Button } from '@components/Button';
import Typography from '@components/Typography';
import { PriceBoxWrapper } from './style';

import type { LayerInfo } from '@lib/types';

const LayerStore = getLayerStore();
type Props = {
  isExpanded: boolean;
  layer: LayerInfo;
};

const PriceBox = observer(({ isExpanded, layer }: Props) => {
  const minPrice = LayerStore.priceBoxData.minPriceApartmentBuy;
  const maxPrice = LayerStore.priceBoxData.maxPriceApartmentBuy;
  const avgPrice = LayerStore.priceBoxData.avgPriceApartmentBuy;

  const router = useRouter();
  const address = router.query.address && decodeURIComponent(router.query.address as string);
  const streetName = getStreetNameFromAddress(address);
  const metaContent = getMetaContent(layer, streetName);

  const handleClick = (): void => {
    LayerStore.setVisibilityWidgetX(true);
  };

  return (
    <PriceBoxWrapper className={classNames({ 'price-box-wrapper': true, collapsed: !isExpanded })}>
      <Typography type="B1" className="price-title" as="h1">
        {metaContent.boxTitle}
      </Typography>
      {minPrice && maxPrice ? (
        <Typography as="p" type="H2" className="price-value">
          <span>
            <span>{formatPrice(minPrice)}</span> <span>-</span> <span>{formatPrice(maxPrice)}</span>
          </span>{' '}
          <span>€/m²</span>
        </Typography>
      ) : (
        <Typography as="p" type="H2" className="price-value">
          <span>{formatPrice(avgPrice)}</span> <span> €/m²</span>
        </Typography>
      )}

      <div className="expand-box">
        <Typography type="B2">
          Erweitern Sie Details Ihrer Immobilie um einen präziseren Wert zu ermitteln.
        </Typography>
        <Button onClick={handleClick} primary large className="CTA">
          Jetzt Details erweitern
        </Button>
      </div>
    </PriceBoxWrapper>
  );
});

export { PriceBox };
